module.exports = __webpack_public_path__ + "static/media/facebook.6534a8a4.svg";